import isExercise from './isExercise';
import getChaptersFromItems from './getChaptersFromItems';
import getTocItemLabelFromType from './getTocItemLabelFromType';
import getItem from './getItem';
import getItemPartId from './getItemPartId';
import isLastCourseChapter from './isLastCourseChapter';

export default {
  getChaptersFromItems,
  getTocItemLabelFromType,
  isExercise,
  getItem,
  getItemPartId,
  isLastCourseChapter,
};
